var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CanvasResult',{attrs:{"anim":_vm.table,"game-state":_vm.gameState,"score":_vm.score,"window-focus":_vm.windowFocus},on:{"showResult":_vm.showResult}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }